module.exports = __webpack_public_path__ + "static/scale-model-of-circle-of-palms-plaza-in-san-jose-california-a4eef7666311144c6cee073e7bd98379.png";